import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99')
];

export const server_loads = [];

export const dictionary = {
		"/": [9],
		"/actors": [10],
		"/actors/[id]": [11],
		"/admin": [12],
		"/admin/credentials": [13],
		"/admin/dlq": [14],
		"/admin/jobs": [15],
		"/admin/llm/errors": [16],
		"/admin/llm/models": [17],
		"/admin/llm/prices": [18],
		"/admin/llm/profiles": [19],
		"/admin/llm/providers": [20],
		"/admin/llm/publish": [21],
		"/admin/llm/routing": [22],
		"/admin/organizations": [23],
		"/admin/organizations/new": [25],
		"/admin/organizations/[id]": [24],
		"/admin/quotas": [26],
		"/admin/registrations": [27],
		"/admin/usage": [28],
		"/admin/users": [29],
		"/budget": [30],
		"/characters": [31],
		"/characters/[id]": [32],
		"/closed-landing": [33],
		"/contact": [34],
		"/dashboard": [35],
		"/dev/ribbon-demo": [36,[2]],
		"/dev/schedule-wasm": [37,[2]],
		"/dev/viewer": [38,[2]],
		"/director": [39],
		"/element-library": [40],
		"/emulator": [41],
		"/equipment": [42],
		"/estimations": [43],
		"/filming-locations": [44],
		"/forgot-password": [45],
		"/invite": [46],
		"/invite/owner": [47],
		"/jobs": [48],
		"/locations": [49],
		"/login": [50,[3]],
		"/magic-link": [51],
		"/master-board": [52],
		"/onboarding": [53],
		"/organization/settings": [54,[4]],
		"/organization/settings/audit": [55,[4]],
		"/organization/settings/billing": [56,[4]],
		"/organization/settings/budget-charts": [57,[4]],
		"/organization/settings/general": [58,[4]],
		"/organization/settings/invitations": [59,[4]],
		"/organization/settings/labor-rules": [60,[4]],
		"/organization/settings/members": [61,[4]],
		"/organization/settings/rate-libraries": [62,[4]],
		"/organization/settings/roles": [63,[4]],
		"/organization/settings/webhooks": [64,[4]],
		"/privacy": [65,[5]],
		"/projects": [66],
		"/projects/new": [69],
		"/projects/settings": [70],
		"/projects/[id]/master-board": [67],
		"/projects/[id]/scripts/[scriptId]": [68,[6]],
		"/props": [71],
		"/red-flags": [72],
		"/reports": [73],
		"/reports/schedule-summary": [74],
		"/reports/shot-progress": [75],
		"/reset-password": [76],
		"/scenes": [77],
		"/scenes/[id]": [78],
		"/scenes/[id]/moodpictures": [79],
		"/schedules": [80],
		"/schedules/call-sheet-access/[access_token]": [85],
		"/schedules/shared/[organization_id]/[secret_key]": [86],
		"/schedules/[id]": [81,[7]],
		"/schedules/[id]/call-sheet": [82,[7]],
		"/schedules/[id]/dood": [83,[7]],
		"/schedules/[id]/resources": [84,[7]],
		"/scripts-details": [88],
		"/scripts-details/[id]": [89],
		"/scripts": [87],
		"/settings": [90],
		"/settings/crew-presets": [91],
		"/settings/notifications": [92],
		"/shot-tracker": [93],
		"/start": [94],
		"/terms": [95,[8]],
		"/upload": [96],
		"/verify-email": [97],
		"/warnings": [98],
		"/workshop": [99]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';